import { ChangeEvent, FC } from 'react';

interface FormSelectProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
  error?: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
}

export const FormSelect: FC<FormSelectProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  options,
  error,
  required = false,
  placeholder = 'Select an option',
  className = '',
}) => {
  const baseStyle = 'mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:outline-none focus:ring-1';
  const errorStyle = 'border-red-300 focus:border-red-500 focus:ring-red-500';
  const normalStyle = 'border-gray-300 focus:border-teal-500 focus:ring-teal-500';

  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`${baseStyle} ${error ? errorStyle : normalStyle}`}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};
